<script lang="ts">
	import Button, { type ButtonProps } from '$lib/shadcn/components/ui/button/button.svelte';
	import { Spinner } from '$lib/shadcn/components/ui/spinner';
	import type { Snippet } from 'svelte';
	import AsyncAction, { type AsyncActionResult } from './AsyncAction.svelte';

	export type SpinnerButtonProps = {
		action: () => AsyncActionResult;
		children: Snippet;
		loading?: Snippet;
	} & Omit<ButtonProps, 'loading'>;
	let {
		action,
		children: content,
		loading: loadingSnippet,
		...restProps
	}: SpinnerButtonProps = $props();
</script>

<AsyncAction {action}>
	{#snippet children(loading, run)}
		<Button onclick={run} {...restProps} disabled={loading || restProps?.disabled}>
			{#if loading}
				<Spinner />
			{/if}
			{#if loading && loadingSnippet}
				{@render loadingSnippet()}
			{:else}
				{@render content()}
			{/if}
		</Button>
	{/snippet}
</AsyncAction>
